const PREFIX = 'bravissimo/countries/';

export const RECEIVE_COUNTRIES = `${PREFIX}RECEIVE_COUNTRIES`;
export const GET_COUNTRIES_REQUEST = `${PREFIX}GET_COUNTRIES_REQUEST`;
export const GET_COUNTRIES_ERROR = `${PREFIX}GET_COUNTRIES_ERROR`;
